import React, {Component} from 'react'
import {Form, Popconfirm, Spin, Table,message} from "antd";
import UserOrderSubSetModalForm from "./user-order-sub-set-modal"
import LinkButton from "../../components/link-button";
import ajax from "../../api/ajax";
import {baseUrl} from "../../api";
import EditCell,{EditableContext} from "../../components/Editable/edit-cell";
const wx_ser_url= baseUrl.split("/").slice(0,3).join("/")+"/wechat"
const PAGE_SIZE = 10;
class UserSubTable extends Component{
    state = {
        loading: false,
        visible: false,
        pageNum:1,
        editingKey:"",
        params:{},
    }
    subStatus={
        "subscribe":"正常",
        "unsubscribe":"已退订"
    }
    levels={
        1:"一般",
        2:"严重"
    }
    dosub=(id)=>{
        this.setState({
            loading:true,
        })
        let params = new FormData();
        params.append("id",id)
        params.append("action","SUB")
        let result = ajax(baseUrl+"/api/v1/p/subscribeInfo",params,"POST");
        result.then((resp)=>{
            if(resp.code === 200){
                this.getUserSubList(this.state.params)
            }else{
            }
        }).catch(()=>{
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    unsub=(id)=>{
        this.setState({
            loading:true,
        })
        let params = new FormData();
        params.append("id",id)
        params.append("action","UNSUB")
        let result = ajax(baseUrl+"/api/v1/p/subscribeInfo",params,"POST");
        result.then((resp)=>{
            if(resp.code === 200){
                this.getUserSubList(this.state.params)
            }else{
            }
        }).catch(()=>{
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    doupd=(id,username,level)=>{
        this.setState({
            loading:true,
        })
        let params = new FormData();
        if(!username){
            username=""
        }
        params.append("id",id)
        if(username){
            params.append("username",username)
        }
        if(level){
            params.append("level",level)
        }
        params.append("action","UPDATE")
        let result = ajax(baseUrl+"/api/v1/p/subscribeInfo",params,"POST");
        result.then((resp)=>{
            if(resp.code === 200){
                this.getUserSubList(this.state.params)
            }else{
            }
        }).catch(()=>{
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    dodel=(id,openId)=>{
        this.setState({
            loading:true,
        })
        let params = {
            id:id,
            openid:openId
        }
        let result = ajax(baseUrl+"/api/v1/p/subscribe",params,"DELETE");
        result.then((resp)=>{
            if(resp.code === 200){
                this.getUserSubList(this.state.params)
            }else{
            }
        }).catch(()=>{
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    updateVisible =(visible)=>{
        this.setState({
            visible:visible
        })
    }
    getUserSubList=(params=null)=>{
        console.log(params,'params')
        this.setState({
            loading:true,
        })
        if(!params || !params.pageNum) {
            if(!params){
                params = this.state.params
            }
            params = Object.assign(params,{
                pageNum: this.state.pageNum,
                pageSize: PAGE_SIZE
            })
        }
        let result = ajax(baseUrl+"/api/v1/p/subscribeInfos",params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    total: resp.data.total,
                    tableDataSource:resp.data.rows
                })
            }else{
                this.setState({
                    total: 0,
                    tableDataSource:[]
                })
            }
        }).catch(()=>{
            this.setState({
                total: 0,
                tableDataSource:[]
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }

    isEditing = record => record.id === this.state.editingKey;
    edit(key) {
        this.setState({ editingKey: key });
    }
    cancel = () => {
        this.setState({ editingKey: '' });
    };
    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...this.state.tableDataSource];
            const index = newData.findIndex(item => key === item.id);
            if (index > -1) {
                const item = newData[index];
                let newItem = Object.assign(item,row)
                newData.splice(index, 1, {
                    ...item,
                    ...newItem,
                });
                this.doupd(item.id,row.userName,row.level)
                this.setState({ tableDataSource: newData, editingKey: '' });
            } else {
                //newData.push(row);
                this.setState({ tableDataSource: newData, editingKey: '' });
            }
        });
    }
    getWeixinUser=(id,openId)=>{
        let result = ajax(wx_ser_url+"/user?openId="+openId);
        result.then((resp)=>{
            if(resp) {
                let result = ajax(baseUrl + "/d/public/wechatUser", {id,nickname:resp.nickname,address:resp.country+resp.province+resp.city}, "PUT");
                result.then((resp) => {
                    if (resp && resp.code === 200) {
                        this.getUserSubList(this.state.params)
                    } else{
                        message.error(resp.message)
                    }
                }).finally(() => {

                })
            }else {
                message.error('未获取到微信信息')
            }
        })
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.params!=this.state.params) {
            this.setState({
                params: nextProps.params
            },()=>{
                this.getUserSubList(nextProps.params)
            })
        }
    }
    render() {
        const components = {
            body: {
                cell: EditCell,
            },
        };
        const columns = [
            {
                title: '微信昵称',
                dataIndex: 'nickName',
                key: 'nickName',
            },
            {
                title: '地区',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '姓名',
                dataIndex: 'userName',
                key: 'userName',
                editable: true,
                required: false,
            },
            {
                title: '等级',
                dataIndex: 'level',
                key: 'level',
                editable: true,
                required: true,
                options:this.levels,
                render: (text,record) => (
                    <span>
                        {this.levels[text]}
                    </span>
                )
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                render: (text,record) => (
                    <span>
                        {this.subStatus[text]}
                    </span>
                )
            },
            {
                title: '操作',
                dataIndex: 'opt',
                key: 'opt',
                fixed: 'right',
                width: 300,
                render: (text,record) => {
                    const { editingKey } = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                        <span>
                          <EditableContext.Consumer>
                            {form => (
                                <a
                                    onClick={() => this.save(form, record.id)}
                                    style={{marginRight: 8}}
                                >
                                    保存
                                </a>
                            )}
                          </EditableContext.Consumer>
                          <a  onClick={() => this.cancel()}>取消</a>
                        </span>
                    ) : (
                        <span>
                        {record.status === "subscribe" ? <LinkButton onClick={() => this.unsub(record.id)}>退订</LinkButton> : <LinkButton onClick={() => this.dosub(record.id)}>订阅</LinkButton>}
                            <LinkButton onClick={() => {
                                this.setState({
                                    visible: true,
                                    openId: record.openId
                                })
                            }}>告警设置</LinkButton>
                            <LinkButton disabled={editingKey !== ''}
                                        onClick={() => this.edit(record.id)}>修改</LinkButton>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.dodel(record.id,record.openId)}>
                            <a>删除</a>
                          </Popconfirm>
                          {/*  {!record.nickName || record.nickName == 'null'? <Popconfirm title="是否确定获取微信信息?" onConfirm={() => this.getWeixinUser(record.id,record.openId)}>
                                <LinkButton>获取微信信息</LinkButton>
                            </Popconfirm>:null}*/}
                    </span>
                    )
                }

            },
        ];
        const editCols = columns.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'id' ? 'number' : 'text',
                    options:col.options,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    required:col.required,
                    editing: this.isEditing(record),
                }),
            };
        });
        return (
            <div>
                <Spin size="large" spinning={this.state.loading}>
                    <EditableContext.Provider value={this.props.form}>
                        <Table
                            components={components}
                            rowKey='id'
                            size="middle"
                            bordered
                            rowClassName="editable-row"
                            columns={editCols}
                            dataSource={this.state.tableDataSource}
                            pagination={{
                                current: this.state.pageNum,
                                total:this.state.total,
                                pageSize:PAGE_SIZE,
                                showQuickJumper: true,
                                onChange:(page, pageSize)=>{
                                    this.setState({
                                        pageNum:page
                                    },()=>{
                                        this.getUserSubList()
                                    })
                                }
                            }}
                        />
                    </EditableContext.Provider>
                </Spin>
                <UserOrderSubSetModalForm visible={this.state.visible} openId={this.state.openId} updateVisible={this.updateVisible} />
            </div>
        )
    }
}
const UserSubEditableTable = Form.create()(UserSubTable)
export default UserSubEditableTable